import React from "react";
import * as styles from "./WithdrawContent.module.scss";

export const WithdrawContent = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <div className={styles.container}>{children}</div>;
};
